import Page from './layouts/Page';
import formStyles from './styles/Forms.module.scss';

const ContactUs = () => {
  const submitContactForm = (e: any) => {
    e.preventDefault();
  };
  return (
    <Page>
      <h1>Contact Us</h1>
      <form onSubmit={(e) => submitContactForm(e)} className={formStyles.form}>
        <div className={formStyles.emptySpace}></div>

        <div className={formStyles.formControl}>
          <label htmlFor="">First Name</label>
          <input name="firstName" id="firstName" type="text" />
        </div>
        <div className={formStyles.formControl}>
          <label htmlFor="">Last Name</label>
          <input name="lastName" id="lastName" type="text" />
        </div>

        <div className={formStyles.formControl}>
          <label htmlFor="">Business Email</label>
          <input name="email" id="password" type="email" />
        </div>

        <div className={formStyles.formControl}>
          <label htmlFor="">Phone</label>
          <input name="phone" id="phone" type="text" />
        </div>

        <div className={formStyles.formControl}>
          <label htmlFor="">Country</label>
          <input name="country" id="country" type="text" />
        </div>

        <div className={formStyles.formControl}>
          <label htmlFor="">Message</label>
          <textarea rows={5} name="message" id="message"></textarea>
        </div>

        <div className={formStyles.formControl}>
          <label htmlFor=""></label>
          <button type="submit" className={formStyles.submit}>
            Submit Form
          </button>
        </div>
      </form>
    </Page>
  );
};

export default ContactUs;
